<template>
  <b-modal id="gewinneModal" ref="gewinneModal" hide-footer>
    <h1 class="text-center">Ein gratis Film bei CHILI</h1>
    <p class="text-center">
      Abonniere den Family-Newsletter und nutze die tolle Chence auf einen Code für einen gratis Film auf der Onlinestreaming-Plattform CHILI.
    </p>

    <b-row class="justify-content-center">
      <b-col col="12" class="text-center">
        <img class="img-fluid mb-30" src="/assets/images/HappyMeal-Chilli-Publication-572x380-v2.jpg" width="100%" height="380"/>
        <!-- Info Text
          <p><strong></strong></p>
        -->
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
export default {
  name: "gewinneModal"
};
</script>
